import axios from 'axios'
import { startLoading, endAjaxLoading } from '@/util/loading'
import respHandler from './respHandler'
import DOMPurify from 'dompurify'
import allowedHtmlTag from '@/util/allowedHtmlTag'
import qs from 'qs'
import { Message } from 'element-ui'
import store from '@/store'
import { getSourceHeader } from '../../util/source'

const instance = axios.create()
const instanceExternal = axios.create()
let isPassed = true

const iterateData = obj => {
  Object.keys(obj).forEach(function(key) {
    if (obj[key] !== null && typeof obj[key] === 'object') {
      iterateData(obj[key])
      return
    }
    if (typeof obj[key] === 'string') {
      const usedKey = DOMPurify.sanitize(obj[key], { ALLOWED_TAGS: allowedHtmlTag })
      if (usedKey != obj[key]) {
        isPassed = false
      }
    }
  })
}

const getRelatedAuths = url => {
  const requiredAuths = store.state.common.requiredAuths
  switch (url) {
    case '/web-api/api/withdrawal/applyWithdrawal':
      return requiredAuths['withdraw']
  }
}

// 修改post请求数据格式
instance.interceptors.request.use(
  async config => {
    isPassed = true
    if (!config.byPassLoading) {
      startLoading('ajax')
    }

    const appUserInfo = JSON.parse(localStorage.getItem('appUserInfo') || '{}')
    const { appUserId, appToken, sign, device, xtoken } = appUserInfo
    if (device) {
      config.headers['appUserId'] = appUserId
      config.headers['appToken'] = appToken
      config.headers['sign'] = sign
      config.headers['xtoken'] = xtoken
    }

    let headerValues = store.state.common.authHeaders
    const requiredAuths = (await getRelatedAuths(config.url, config.data)) || []
    headerValues = {
      etxId: requiredAuths.filter(item => item == 'email').length > 0 ? headerValues.etxId : '',
      eCode: requiredAuths.filter(item => item == 'email').length > 0 ? headerValues.eCode : '',
      tCode: requiredAuths.filter(item => item == 'totp').length > 0 ? headerValues.tCode : '',
      ptxId: headerValues.ptxId,
      pCode: headerValues.pCode,
    }
    config.headers['Multi-Auth-Validate'] = [
      headerValues.etxId,
      headerValues.eCode,
      headerValues.tCode,
      headerValues.ptxId,
      headerValues.pCode,
    ]

    if (process.env.VUE_APP_ENV_MODE !== 'production') {
      config.headers['branchVersion'] = process.env.BRANCH_VERSION
      config.headers['tag'] = process.env.TAG
    }

    config.withCredentials = true

    // 添加x-source
    config.headers['x-source'] = getSourceHeader()
    config.headers['x-response-format'] = 'pc'



    // append session id
    const sessionId = store.state.common.sessionId
    const sessionInternalId = store.state.common.sessionInternalId
    // If session ID exists, add it to the headers
    if (sessionId && sessionInternalId) {
      config.headers['X-Tool-Session-Id'] = sessionId
      config.headers['X-Tool-Session-Internal-Id'] = sessionInternalId
    }

    if (config.method === 'post') {
      isPassed = true
      const data = config.data

      if (typeof data === 'string') {
        const parseData = qs.parse(data)
        iterateData(parseData)
        const stringifyData = qs.stringify(parseData)

        const sanitizedData = DOMPurify.sanitize(stringifyData, {
          ALLOWED_TAGS: allowedHtmlTag,
        })

        // Compare sanitized data with stringify data instead of original data
        // qs.stringify will append "=" for empty value
        // https://github.com/nodejs/node/issues/9500
        if (sanitizedData !== stringifyData) {
          isPassed = false
        }
      }

      if (typeof data === 'object') {
        iterateData(config.data)
      }
    }
    if (!isPassed) {
      promptUnauthorizedError()
      throw new Error('Error')
    }
    return config
  },
  function(error) {
    return Promise.reject(error)
  }
)

// 修改post请求数据格式
instance.interceptors.response.use(
  resp => respHandler(resp),
  function(error) {
    endAjaxLoading()

    // 401 鉴权处理，需要正常的提示message
    if (error.response && error.response.status === 401) {
      return Promise.resolve(respHandler(error.response))
    } else {
      // 不确定下面代码是否有特殊作用，先保留
      Message({
        type: 'error',
        message:
          error.response && error.response.data && error.response.data.length <= 50
            ? error.response.data
            : 'Error occurred while processing your request.',
      })
    }

    return Promise.reject(error)
  }
)

function promptUnauthorizedError() {
  Message({
    message: 'Unauthorized symbols detected. Please remove them and try again.',
    type: 'error',
  })
  return Promise.reject('XSS Issue')
}

export { instance, instanceExternal }
